
import { i18nextInit, i18next, localize  } from "./components/i18next-init.js";

const initAsyncI18Next = async () => {

	// init i18next, and apply localization to the body
	await i18nextInit(); // ensure i18next and localize are initialized
	window.i18next = i18next;

	if (localize) {
		window.localize = localize;

		if (document.readyState === "loading") { // if document is still loading, localize once DOM Content has been fully loaded
			document.addEventListener("DOMContentLoaded", () => {
				localize("body");
			});
		}
		else { // if DOM is already loaded (i.e. from cache), localize immediately
			localize("body");
		}
	}
};

window.i18nextReady = initAsyncI18Next(); // make promise available to start using i18next in JS asap with "i18nextReady.then(() => { i18next.t('key'); })" block from CMS for example
